import AGREGAR_CONTRATO_ARCHIVO_CONTRATISTA from '@/graphql/mutations/administracion/contratos/contrato/archivos-contratista/agregarContratoArchivoContratista.gql';
import ACTUALIZAR_CONTRATO_ARCHIVO_CONTRATISTA from '@/graphql/mutations/administracion/contratos/contrato/archivos-contratista/actualizarContratoArchivoContratista.gql';
import REMOVER_CONTRATO_ARCHIVO_CONTRATISTA from '@/graphql/mutations/administracion/contratos/contrato/archivos-contratista/removerContratoArchivoContratista.gql';
import CONTRATO_ARCHIVOS_CONTRATISTA from '@/graphql/querys/administracion/contratos/contrato/archivos-contratista/contratoArchivosContratista.gql';
import CATALOGO_TIPO_ARCHIVO_CONTRATISTA from '@/graphql/querys/administracion/contratos/contrato/archivos-contratista/tipos-archivivos-contratista/catalogoTiposArchivosContratista.gql';

export default {
  apollo: {
    // Cargar Catalogo de Tipo de Archivo Contratista
    catalogoTiposArchivosContratista: {
      query: CATALOGO_TIPO_ARCHIVO_CONTRATISTA,
    },
  },
  methods: {
    // Agregar Archivo
    async mixAgergarContratoArchivoContratista() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo
        .mutate({
          mutation: AGREGAR_CONTRATO_ARCHIVO_CONTRATISTA,
          variables: {
            archivo: this.archivo,
          },
          update: (store, { data: { agregarContratoArchivoContratista } }) => {
            const query = {
              query: CONTRATO_ARCHIVOS_CONTRATISTA,
              variables: {
                idContrato: this.idContrato,
              },
            };
            const { contratoArchivosContratista } = store.readQuery(query);
            const contratoArchivosContratistaCopia = contratoArchivosContratista.slice();
            contratoArchivosContratistaCopia.push(agregarContratoArchivoContratista);
            store.writeQuery({
              ...query,
              data: {
                contratoArchivosContratista: contratoArchivosContratistaCopia,
              },
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    // Actualizar Archivo
    async mixActualizarContratoArchivoContratista() {
      this.enviandoFormulario = true;
      this.mixEsCargando();
      await this.$apollo
        .mutate({
          mutation: ACTUALIZAR_CONTRATO_ARCHIVO_CONTRATISTA,
          variables: {
            id: this.contratoArchivoContratistaEditar.id,
            archivo: this.archivo,
          },
          update: (store, { data: { actualizarContratoArchivoContratista } }) => {
            const query = {
              query: CONTRATO_ARCHIVOS_CONTRATISTA,
              variables: {
                idContrato: this.contratoArchivoContratistaEditar.idContrato,
              },
            };
            const data = store.readQuery(query);
            const { contratoArchivosContratista } = data;
            const index = contratoArchivosContratista.findIndex(
              (contratoArchivoContratista) => contratoArchivoContratista.id
                === actualizarContratoArchivoContratista.id,
            );
            if (index !== -1) {
              contratoArchivosContratista.splice(index, 1, actualizarContratoArchivoContratista);
            }
            store.writeQuery({ ...query, data });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    // Eliminar Archivo
    async mixEliminarContratoArchivoContratista() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo
        .mutate({
          mutation: REMOVER_CONTRATO_ARCHIVO_CONTRATISTA,
          variables: {
            id: this.contratoArchivoContratistaEliminar.id,
          },
          update: (store) => {
            const query = {
              query: CONTRATO_ARCHIVOS_CONTRATISTA,
              variables: {
                idContrato: this.contratoArchivoContratistaEliminar.idContrato,
              },
            };
            const data = store.readQuery(query);
            const { contratoArchivosContratista } = data;
            const index = contratoArchivosContratista.findIndex(
              (archivo) => archivo.id === this.contratoArchivoContratistaEliminar.id,
            );
            if (index !== -1) {
              contratoArchivosContratista.splice(index, 1);
            }
            store.writeQuery({ ...query, data });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },
  computed: {
    getCatalogoTipoArchivoContratista() {
      if (!this.catalogoTiposArchivosContratista) return [];
      return this.catalogoTiposArchivosContratista;
    },
  },
};
